import * as React from "react";
import { forwardRef } from "react";
const SvgA11YmenuFunnelChart = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", stroke: "currentColor", strokeLinejoin: "round", strokeMiterlimit: 10, strokeWidth: 1.5, d: "M2 3h20l-6.953 11.804V21H8.926v-6.171L2 3ZM5.58 9.208h12.77M8.926 14.829h6.121" }));
const ForwardRef = forwardRef(SvgA11YmenuFunnelChart);
export { ForwardRef as ReactComponent };
